import {Box, CloseButton, Flex, HStack, Text, useDisclosure, VStack} from '@chakra-ui/react';
import {TitledSection} from 'components/layouts/aside-layout';
import {colors, useCartContext} from 'components/providers';
import {Counter, ProductDetailsModal} from 'components/shared';
import {useTranslation} from 'hooks';
import {useState} from 'react';
import {ICartItem} from 'types';
import ImageUI from 'ui/ImageUI';

export const CartItemsMetroRestaurant = () => {
  const {onOpen, isOpen, onClose} = useDisclosure();
  const {t} = useTranslation();
  const [selectedCartItem, setSelectedCartItem] = useState<ICartItem>();

  const {
    cartItems,

    changeCartItemQuantity,
    cartProvider,
    editCartItem,
    deleteProduct,
    requiredProducts,
  } = useCartContext();

  const handleOpenProductModal = (product: ICartItem) => {
    setSelectedCartItem(product);
    onOpen();
  };

  return (
    <TitledSection>
      <VStack spacing={0} justifyContent="stretch" h="full">
        <Box overflowY="auto" flex="1" w="100%">
          {cartItems.map((item) => (
            <Box key={item.productId} p={4} onClick={() => handleOpenProductModal(item)}>
              <HStack spacing={3} align="flex-start">
                <Box w="100px" h="100px" flexShrink={0} borderColor="gray.300" borderWidth={1} borderRadius="10px">
                  <ImageUI
                    src={item.product?.product_img_for_list_thumbnail || ''}
                    alt={item.product?.name || ''}
                    borderRadius="8px"
                    fallbacksrc="/food_pattern.png"
                    w="100%"
                    h="100%"
                    objectFit="cover"
                  />
                </Box>

                <Flex flex={1} direction="column">
                  <HStack justify="space-between" align="flex-start">
                    <Text fontSize="12px" color="gray.800" flex={1} noOfLines={2}>
                      {item.product?.name}
                    </Text>
                    <CloseButton size="sm" color="gray.400" onClick={() => deleteProduct(item.id)} />
                  </HStack>

                  {item.product?.measurement_display && (
                    <Text color={colors.textGray} fontSize="12px" mt={1}>
                      {item.product.measurement_display}
                    </Text>
                  )}

                  <HStack justify="space-between" align="center" mt={3}>
                    <Box w="50%">
                      <Counter
                        isSmallSize
                        onChange={(qty) => {
                          changeCartItemQuantity(item.id, qty);
                        }}
                        defaultValue={item.quantity}
                        min={0}
                      />
                    </Box>
                    <HStack spacing={2} align="baseline">
                      {item.product?.discount_price && item.product?.discount_price < item.price ? (
                        <>
                          <Text fontSize="12px" color={colors.textGray} textDecoration="line-through">
                            {item.product.price * item.quantity} {t('CURRENCY')}
                          </Text>
                          <Text fontSize="16px" fontWeight="600" color="gray.800">
                            {item.product.discount_price * item.quantity} {t('CURRENCY')}
                          </Text>
                        </>
                      ) : (
                        <Text fontSize="16px" fontWeight="600" color="gray.800">
                          {item.price * item.quantity} {t('CURRENCY')}
                        </Text>
                      )}
                    </HStack>
                  </HStack>
                </Flex>
              </HStack>
            </Box>
          ))}

          {requiredProducts.map((item, index) => (
            <Box
              key={index}
              borderBottom={index < requiredProducts.length - 1 ? '1px solid' : 'none'}
              borderColor={colors.borderGray}
              p={4}
            >
              <HStack spacing={3} align="flex-start">
                <Box w="60px" h="60px" flexShrink={0}>
                  <ImageUI
                    src={item.product_img_for_list_thumbnail}
                    alt={item.name}
                    borderRadius="8px"
                    fallbacksrc="/food_pattern.png"
                    w="100%"
                    h="100%"
                    objectFit="cover"
                  />
                </Box>

                <Flex flex={1} direction="column">
                  <Text fontSize="14px" fontWeight="500" lineHeight="1.3" color="gray.800" noOfLines={2}>
                    {item.name}
                  </Text>

                  {item.measurement_display && (
                    <Text color={colors.textGray} fontSize="12px" mt={1}>
                      {item.measurement_display}
                    </Text>
                  )}

                  <HStack justify="space-between" align="center" mt={3}>
                    <Text fontSize="16px" fontWeight="600" color="gray.800">
                      1
                    </Text>
                    <Text fontSize="16px" fontWeight="600" color="gray.800">
                      {item.price} {t('CURRENCY')}
                    </Text>
                  </HStack>
                </Flex>
              </HStack>
            </Box>
          ))}
        </Box>
      </VStack>

      {isOpen && selectedCartItem && (
        <ProductDetailsModal
          isFromEdit
          isOpen={isOpen}
          onClose={onClose}
          product={selectedCartItem.product}
          selectedCartItem={selectedCartItem}
          onEdit={editCartItem}
          t={t}
          providerSlug={cartProvider?.slug}
        />
      )}
    </TitledSection>
  );
};
